export default {
  data() {
    return {
      archivo: null,
      previsualizacion: null,
      archivoBase64: null,
      esImagen: false,
      esPDF: false,
    };
  },
  methods: {
    resetearVariablesPrevisualizacion() {
      this.archivo = null;
      this.previsualizacion = null;
      this.archivoBase64 = null;
      this.esImagen = false;
      this.esPDF = false;
    },
    onFileChange() {
      if (this.archivo) {
        const reader = new FileReader();
        const fileType = this.archivo.type;

        reader.onload = (e) => {
          const result = e.target.result;

          this.archivoBase64 = result.split(',')[1];
          this.archivoExtension = this.archivo.name.split('.').pop();
          this.archivoMimetype = fileType;

          if (fileType.includes('image')) {
            this.previsualizacion = result;
            this.esImagen = true;
            this.esPDF = false;
          } else if (fileType.includes('pdf')) {
            const blob = new Blob([this.archivo], { type: fileType });
            const url = URL.createObjectURL(blob);

            this.previsualizacion = url;
            this.esImagen = false;
            this.esPDF = true;
          } else {
            this.previsualizacion = null;
            this.esImagen = false;
            this.esPDF = false;
          }
        };

        reader.readAsDataURL(this.archivo);
      } else {
        this.previsualizacion = null;
        this.esImagen = false;
        this.esPDF = false;
        this.archivoBase64 = null;
      }
    },
  },
};
